export default "__VITE_ASSET__I9dVMCLl__"